import { Link} from 'react-router-dom';
import { useContext, useEffect, useState } from "react";
import { UserContext } from '../../context/UserContext';
import Navigation from "../../Components/Navbar";
import { Container, Table } from "react-bootstrap";
import api from "../../Components/Api/Api";
import Spinner from "../../Components/Spinner";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import './index.scss';
const Aprovacaodesconto = () => {
    const {user} = useContext(UserContext)
    const [ShowLoading, setShowLoading] = useState(false)  
    const [atualizar, setAtualizar] = useState(false) 
    const [dtini, setDtini] = useState('')
    const [dtfim, setDtfim] = useState(Date)  
    const [orcamentos, setOrcamentos] = useState<any[]>([])    
    const [page, setPage] = useState(0)
    const [perpage, setPerpage] = useState(10)
    const [empresa, setEmpresa] = useState('')
    const [filial, setfilial] = useState('')
    const [linhastotal, setLinhastotal] = useState(0)
    //const [obs, setObs] = useState('')
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agente": "PneusBrasil",
        "Accept": "*/*",
        'Authorization': `Basic ${credentials}`,
      }
    interface Itens {
        Cliente: string;
        Codvededor: string;
        Filial: string;
        Hrcriado: string;
        Loja: string;
        Motbloqueio: string;
        Nome: string;
        Obs: string;
        Orcamento: string;
        Perdesconto: number;
        Tipopag: string;
        Vldescon: number;
        Vlliquido: number;
        Vlpedido: number;
        id: string;
        linhas: string;       
    }
    let itens: Itens[] = [];
    const getdate = (el: any) => {
        if(el.target.id === 'data1' && el.target.value !== ''){
          //console.log("data 1 ",el.target.value.split('-').join(''))
          setDtini(el.target.value.split('-').join(''))
        }else if (el.target.id === 'data2' && el.target.value !== ''){ 
          //console.log("data 2 ",el.target.value.split('-').join(''))
          setDtfim(el.target.value.split('-').join(''))
        }
      } 
    const getempresa = (el: any) => {
        if(el.target.id === 'empresa' && el.target.value !== ''){
            setEmpresa(el.target.value)
        }else if (el.target.id === 'filial' && el.target.value !== '') {
            setfilial(el.target.value)
        }   
      } 
      function getpendencias () {
        setTimeout(() => {
            // const headers = {
            //     'Content-Type': 'application/json;charset=UTF-8',
            //     "Access-Control-Allow-Origin": "*",
            //     "User-Agente": "PneusBrasil",
            //     "Accept": "*/*",
            //     // 'Authorization': "Basic YWRtaW46QE5lbHNvbjEx",
            //   }             
        // if (empresa !== '' && filial !== ''   ){        
            setShowLoading(true)
            api.get('AutorizacaoPendendete?filial='+filial+'&empresa='+empresa+'&Orcamento=&page='+page+'&perpage='+perpage+'&dtini='+dtini+'&dtfim='+dtfim,{headers})
            .then(response => {
                //console.log(response.data.Entradas)
                if (response.data.Pendentes.length > 0 ){   
                    //console.log(response.data.Entradas[0]['Num'])  
                    setOrcamentos(response.data.Pendentes)
                    setLinhastotal(response.data.Pendentes[0]['linhas']) 
                    setAtualizar(true) 
                    setShowLoading(false)                                  
                }else{
                    alert("Nada para exibir no momento!")
                    setShowLoading(false)
                    setAtualizar(true)
                    setOrcamentos([])            
                }                                   
            });
        // } else {
        //     alert("Empresa ou filial não pode esta vazio!")
        // }
        }, 10 );        
      };  
    const paginacao = (sentido: string) => {
    
        if(sentido === 'next' && page < (linhastotal - perpage)){
          console.log(sentido, ' - ',page + perpage)
          setPage(page + perpage)
          setAtualizar(false)
        }
        if(sentido === 'back' && page > 0){
          console.log(sentido, ' - ',page - perpage)
          setPage(page - perpage)
          setAtualizar(false)
        }    
    }     
    const aprovado = (tipo: string,index: any) => {
        if (tipo === 'A'){
            if (empresa !== '' && filial !== ''){
                console.log(orcamentos)
                let it = [...orcamentos]; 
                let answer = window.confirm("Deseja realmente aprovar esse desconto?");           
                if (answer) {
                    handlingenviar(tipo,it[0]["Orcamento"],user.codusuario)
                    it.splice(index,1);
                    itens = [...it];   
                    itens[index].Obs = '';
                    setOrcamentos(itens);                                         
                    //setOrcamentos(it);                 
                } 
            } else {
                alert("Empresa ou filial estão vazios")
            }
        }else if ( tipo === 'N'){ 
            let it = [...orcamentos]; 
            let answer = window.confirm("Deseja realmente reprovar esse desconto?");           
            if (answer) {
                handlingenviar(tipo,it[0]["Orcamento"],user.codusuario)
                it.splice(index,1);
                itens = [...it];   
                itens[index].Obs = '';
                setOrcamentos(itens);                
                //setOrcamentos(it);                 
              }      
        }         
    }
    const handlingenviar = (status: string,numorc: string,coduser: string) =>{
        setShowLoading(true)       
        const url = 'Aprovadesconto?numorc='+numorc;
        // const headers = {
        //     'Content-Type': 'application/json;charset=UTF-8',
        //     "Access-Control-Allow-Origin": "*",
        //     "User-Agente": "PneusBrasil",
        //     "Accept": "*/*",
        //   }         
        const data = {
            'Empresa': empresa,
            'Filial': filial,
            'ZZU_AUTORI': status,
            'ZZU_UAUTOR': coduser,
            'ZZU_OBS': ''         
        }
        api.post(url,data, {headers})
        .then(function (response) {
            if(response.data['info'] === 'erro'){
                setShowLoading(false)
                alert('Erro na alteração! Orçamento: '+ response.data['codigo'])
            }  
            if(response.data['info'] === 'alterdo'){
                setShowLoading(false)
                alert('Orçamento ajustado com sucesso, Orçamento: '+ response.data['codigo'])
            }                                  
        })
        .catch(function (error) {
            console.error(error);
            setShowLoading(false)
            alert('Alert: Erro de conexão com servidor! ')
        });                        
    }
    const getObs = (el: any, index: any) => {
        //setObs(el.target.value)
        itens = [...orcamentos];   
        itens[index].Obs = el.target.value;
        setOrcamentos(itens);  
        //console.log(itens)       
    }
    
    useEffect(() => {
        // if(!atualizar){
        //     getpendencias()
        // }  
    })          
    return (
        <>
            <Navigation />
            <Container>
                <div>
                    <span>Cod. Usuario Aprovador: {user.codusuario}</span>
                </div>
                <div className='mt-2'>
                    <label className='me-md-1' htmlFor="Dt Ini">Dt Ini:</label>
                    <input className='sm-blok' type='date' id='data1' onBlur={(e) => getdate(e)}></input>
                    <label className='ms-md-2 me-1 sm-blok' htmlFor="Dt Fim">Dt Fim:</label>
                    <input className='' type='date' id='data2' onBlur={(e) => getdate(e)}></input>  
                    <label className='ms-md-2 me-1 sm-blok'>Empresa e filial</label>
                    <input className='' size={5} type='text' id='empresa' placeholder="01" onChange={(e) => getempresa(e)}></input> 
                    <label className='me-1 ms-1'>:</label>
                    <input className='' size={5} type='text' id='filial' placeholder="01" onChange={(e) => getempresa(e)}></input>                     

                    <button className='ms-md-2 btn btn-success sm-blok' onClick={getpendencias}>Buscar</button>
                </div> 
                <div className='mt-2'>    
                    <Table striped bordered hover variant="light" responsive className="tabela">
                        <thead>
                        {/* ZZU_FILIAL,ZZU_CODCLI,ZZU_LOJA,ZZU_NUMORC,ZZU_VLPEDI,ZZU_VLDESC,ZZU_PERDES,ZZU_TIPOPG,ZZU_VEND,A3_NOME,ZZU_VLLIQ,ZZU_MOTBLO,ZZU_OBS,ZZU_HRCRIA */}
                            <tr className='col-title'>
                            <th>Id</th>
                            <th>Filial</th>
                            <th>Cod. cliente</th>
                            <th>Loja</th>
                            <th>Orçamento</th>
                            <th>Valor Pedido</th>
                            <th>Desconto</th>
                            <th>Percentual</th> 
                            <th>Valor Liquido</th>
                            <th>tipo pagmento</th> 
                            <th>Cod. Vendedor</th> 
                            <th>Nome</th>  
                            <th>Mot Bloqueio</th> 
                            <th>Obs</th> 
                            <th>Hora</th> 
                            {user.codusuario !== '' ?
                                ( <>                    
                            <th>Açoes</th> 
                            </>):('')                
                            }                
                            </tr>
                        </thead> 
                        <tbody> 
                        {orcamentos.map((list: any,i: any) => (           
                        <tr key={i} id={i} className={i}>
                            <td>{list.id}</td>
                            <td>{list.Filial}</td>
                            <td>{list.Cliente}</td>
                            <td>{list.Loja}</td>
                            <td>{list.Orcamento}</td>
                            <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(list.Vlpedido)}</td>
                            <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(list.Vldescon)}</td>
                            <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(list.Perdesconto)} %</td>
                            <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(list.Vlliquido)}</td>
                            <td>{list.Tipopag}</td>
                            <td>{list.Codvededor}</td>
                            <td>{list.Nome}</td>
                            <td>{list.Motbloqueio}</td>
                            <td><input onChange={(e) => {getObs(e,i)}}></input></td>
                            <td>{list.Hrcriado}</td>
                            {user.codusuario !== '' ?
                                ( <td>                    
                                    <abbr title='Aprovar desconto' className='me-2'>
                                        <button className='btn btn-outline-warning btacoes' onClick={() => {aprovado('A',i)}}><FcApprove size={25} /></button>
                                    </abbr> 
                                    <abbr title='Recusar desconto' className='me-2'>
                                        <button className='btn btn-outline-warning btacoes mt-2' onClick={() => {aprovado('N',i)}}><FcDisapprove size={25} /></button>
                                    </abbr>                                                                   
                                </td>):('')                
                            }
                        </tr>
                        ))}                         
                        </tbody>
                    </Table>                      
                    </div>
                    <div className='mt-4 mb-4'>
                        <button onClick={() => {paginacao('next')}} className='btn btn-outline-success'>Proxima</button>
                        <button onClick={() => {paginacao('back')}} className='btn btn-outline-primary ms-lg-5 ms-4'>Anterior</button>
                        <label className='ms-lg-5 ms-4'>Total de linhas {linhastotal}</label>
                </div>                               
            </Container>
            <Spinner isLoading={ShowLoading} />
        </>
    )
};

export default Aprovacaodesconto;